import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { GraduationCap, Award, ChevronRight, Brain, Dumbbell, Heart, Calendar, Star, Check, ArrowRight, Trophy, Target, Scale } from 'lucide-react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import GatewayMembership from '../components/GatewayMembership';
import Community from '../components/Community';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import TrialPopup from '../components/TrialPopup';

export default function Home() {
  const { scrollYProgress } = useScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.2], [1, 0.95]);

  return (
    <motion.div 
      className="min-h-screen bg-black text-white overflow-x-hidden w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <Navbar />
      <motion.div style={{ opacity, scale }}>
        <Hero />
      </motion.div>

      <Features />
      <GatewayMembership />
      <Community />
      <Testimonials />
      <Footer />
      <TrialPopup />
    </motion.div>
  );
}